import limit from './limit'
import map from './map'
import nth from './nth'
import orderBy from './orderBy'
import skip from './skip'

export default {
  limit,
  map,
  nth,
  orderBy,
  skip
}




// WEBPACK FOOTER //
// ./src/data/api/transformations/index.js